import React, { memo, useMemo } from 'react';
import OpenColumnOrderRow from './OpenColumnOrderRow';
import { OpenColumnVirtualOrdersList } from './OpenColumnVirtualOrdersList';

/**
 * Grupo por cidade na coluna "Em aberto". Deve ser definido fora de App para não remontar
 * a cada render (preserva scroll de .city-orders-container).
 */
function OpenColumnCityGroup({
  cidade,
  ordens,
  codstatusRetorno,
  extraRetornoStatuses,
  openCityDropdown,
  onToggleCityDropdown,
  selectedOrders,
  onSelectAllOrdersFromCity,
  onOrderClick,
  onSetContextMenu,
  onDragStartEnsureSelection,
  onBoardOrderDragStart,
  onBoardOrderDragEnd,
  userShowOSConfig,
  onBoardCellTooltip,
  showStatusColumnEmAberto,
}) {
  const getSLAPriority = (sla) => {
    switch (sla) {
      case 'Vencido':
      case 'vencido':
        return 1;
      case 'Vencendo':
      case 'vencendo':
        return 2;
      case 'Em dia':
      case 'ok':
        return 3;
      default:
        return 4;
    }
  };

  const sortedOrdens = useMemo(() => {
    return [...ordens].sort((a, b) => {
      const priorityA = getSLAPriority(a.sla);
      const priorityB = getSLAPriority(b.sla);
      if (priorityA !== priorityB) return priorityA - priorityB;
      return String(a.id).localeCompare(String(b.id));
    });
  }, [ordens]);

  const extrasSet = useMemo(() => {
    if (!Array.isArray(extraRetornoStatuses) || extraRetornoStatuses.length === 0) return null;
    return new Set(extraRetornoStatuses);
  }, [extraRetornoStatuses]);

  const retornoRef = String(codstatusRetorno || '').trim();

  const isOrderStatusRetorno = (ordem) => {
    const statusOs = String(ordem.TB02115_STATUS || '').trim();
    const requestStatus = String(ordem.os_request_status || ordem.OS_REQUEST_STATUS || '').trim();
    const matches = (value) => {
      if (!value) return false;
      if (retornoRef !== '' && value === retornoRef) return true;
      if (extrasSet && extrasSet.has(value)) return true;
      return false;
    };
    return matches(statusOs) || matches(requestStatus);
  };

  const allSelected = ordens.every((ordem) => selectedOrders.includes(ordem.id));
  const someSelected = ordens.some((ordem) => selectedOrders.includes(ordem.id));

  const rowProps = {
    selectedOrders,
    onOrderClick,
    onSetContextMenu,
    onDragStartEnsureSelection,
    onBoardOrderDragStart,
    onBoardOrderDragEnd,
    userShowOSConfig,
    onBoardCellTooltip,
    showStatusColumnEmAberto,
  };

  return (
    <div className="city-group">
      <div
        className="city-header"
        onClick={ordens.length > 1 ? () => onToggleCityDropdown(cidade) : undefined}
        style={{ cursor: ordens.length > 1 ? 'pointer' : 'default' }}
      >
        <div className="city-title-section">
          <span className="city-title">{cidade}</span>
          <span className="city-count">{ordens.length}</span>
        </div>
        {ordens.length > 1 && (
          <div className="city-actions">
            {someSelected && (
              <div className="city-selection-indicator">{allSelected ? '✓' : '◐'}</div>
            )}
            <span className="city-dropdown-arrow">▼</span>
          </div>
        )}

        {openCityDropdown === cidade && ordens.length > 1 && (
          <div className="city-dropdown">
            <div
              className="city-dropdown-option"
              onClick={(e) => {
                e.stopPropagation();
                onSelectAllOrdersFromCity(ordens);
              }}
            >
              <span className="city-dropdown-icon">{allSelected ? '☐' : '☑'}</span>
              <span className="city-dropdown-text">{allSelected ? 'Desmarcar todas' : 'Selecionar todas'}</span>
              <span className="city-dropdown-count">({ordens.length})</span>
            </div>
          </div>
        )}
      </div>
      <OpenColumnVirtualOrdersList orders={sortedOrdens}>
        {(ordem) => (
          <OpenColumnOrderRow
            ordem={ordem}
            isStatusRetorno={isOrderStatusRetorno(ordem)}
            {...rowProps}
          />
        )}
      </OpenColumnVirtualOrdersList>
    </div>
  );
}

export default memo(OpenColumnCityGroup);
